import { Skeleton, styled } from '@mui/material';

export const CircularSkeleton = styled(Skeleton)(({ width, height }) => ({
  animation: 'wave',
  width,
  height,
  background: '#DBDBDB0D, #DBDBDB',
}));

export const RoundedSkeleton = styled(Skeleton)(({ width, height }) => ({
  animation: 'wave',
  width,
  height,
  background: 'linear-gradient(270deg, rgba(219, 219, 219, 0.05) 0%, #DBDBDB 50%)',
  borderRadius: '15px',
}));
